import moment from 'moment-timezone';
import { DISPLAY_DATE_FORMAT2, DISPLAY_TIME_FORMAT3 } from '../../constants';

export const getDisplayDate = (date) => {
	if (typeof date === "string") return date ? moment.utc(date).format(`${DISPLAY_DATE_FORMAT2}`) : "";
	else return date ? date.format(`${DISPLAY_DATE_FORMAT2}`) : "";
};

export const getDisplayTime = (date) => {
	if (typeof date === "string") return date ? moment.utc(date).format(`${DISPLAY_TIME_FORMAT3}`) : "";
	else return date ? date.format(`${DISPLAY_TIME_FORMAT3}`) : "";
};